<div class="card text-center mx-auto mb-4">
    <div class="card-header">
        <h3>Login</h3>
    </div>
    <div class="card body">
        <form class="form mt-2">

            <div class="form-group">
                <label class="form-label" for="email">Email</label>
                <input type="email" id="email" class="form-control form-control-lg" />
            </div>

            <div class="form-group">
                <label class="form-label" for="password">Password</label>
                <input type="password" id="password" class="form-control form-control-lg" />
            </div>

            <div class="form-group">
                <button class="btn btn-primary btn-lg"type="button">Login</button>
            </div>

            <p class="card-link small mb-5 pb-lg-2"><a href="#!">Hai dimenticato la password?</a></p>
            <!-- <p>Don't have an account? <a href="#!" class="link-info">Register here</a></p> -->
        </form>
    </div>
</div>